"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fdr_lib_ident_auth_config_1 = require("@hotelplan/fdr.lib.ident.auth-config");
const fdr_lib_ident_with_auth_1 = require("@hotelplan/fdr.lib.ident.with-auth");
const fdr_chat_utils_1 = require("./fdr-chat.utils");
function useVisitorDetails(visitorDetails) {
    const { user } = (0, fdr_lib_ident_with_auth_1.useAuthContext)();
    const { userId, channelType } = (0, react_1.useMemo)(() => {
        return {
            userId: user === null || user === void 0 ? void 0 : user.userId,
            channelType: user === null || user === void 0 ? void 0 : user.channel,
        };
    }, [user]);
    return (0, react_1.useEffect)(() => {
        if (channelType === fdr_lib_ident_auth_config_1.AuthChannelType.B2C && visitorDetails) {
            if (visitorDetails) {
                const { fullName, emailAddress, phoneNumber } = visitorDetails;
                if (fullName) {
                    window.olark(fdr_chat_utils_1.CHAT_VISITOR_FULL_NAME, {
                        fullName,
                    });
                }
                if (emailAddress) {
                    window.olark(fdr_chat_utils_1.CHAT_VISITOR_EMAIL_ADDRESS, {
                        emailAddress,
                    });
                }
                if (phoneNumber) {
                    window.olark(fdr_chat_utils_1.CHAT_VISITOR_PHONE_NUMBER, {
                        phoneNumber,
                    });
                }
            }
            if (userId) {
                window.olark(fdr_chat_utils_1.CHAT_VISITOR_CUSTOMER_FIELDS, {
                    customerId: userId,
                });
            }
        }
    }, [channelType, userId, visitorDetails]);
}
exports.default = useVisitorDetails;
//# sourceMappingURL=useVisitorDetails.js.map